import { TRACE_ELEMENT_TYPE } from '../../connectivity/SystemVisualizer';
import { kClickThreshold } from './plugins';

const HANDLE_COLORS = {
	[TRACE_ELEMENT_TYPE.START]: '#61F18A',
	[TRACE_ELEMENT_TYPE.END]: '#CE5B95',
};

const TRACE_HANDLE_SVG =
	'<path d="M22.75 11.75C22.75 17.8251 17.8251 22.75 11.75 22.75C5.67487 22.75 0.75 17.8251 0.75 11.75C0.75 5.67487 5.67487 0.75 11.75 0.75C17.8251 0.75 22.75 5.67487 22.75 11.75Z" fill="currentColor"/>' +
	'<path d="M7.75 9.75H15.75M7.75 13.75H15.75M22.75 11.75C22.75 17.8251 17.8251 22.75 11.75 22.75C5.67487 22.75 0.75 17.8251 0.75 11.75C0.75 5.67487 5.67487 0.75 11.75 0.75C17.8251 0.75 22.75 5.67487 22.75 11.75Z" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round"/>';

export class TraceDragHandleUI {
	/**
	 * @param {PositionedUI} parentUI
	 */
	constructor(parentUI) {
		this.active = false;
		this.parentUI = parentUI;
		this.container = parentUI.innerDom;
		const document = this.container.ownerDocument;

		this.handleHost = createTraceDragHandleHost(document);
		this.iconHost = createTraceDragHandleIcon(document);
		this.handleHost.appendChild(this.iconHost);
		this.container.appendChild(this.handleHost);

		this.boundMouseDown = this.#onHostMouseDown.bind(this);
		this.handleHost.addEventListener('mousedown', this.boundMouseDown);
		
		this.boundHostMove = this.#onHostMouseMove.bind(this);
		this.boundHostUp = this.#onHostMouseUp.bind(this);
	}

	/**
	 *  Updates the background color of the trace drag handle based on the traced type.
	 */
	updateTracedType(tracedType) {
		this.tracedType = tracedType;
		this.handleHost.style.color = HANDLE_COLORS[tracedType];
	}

	isActive() {
		return this.active;
	}

	setActive(active) {
		if (this.active === active) {
			return;
		}

		this.active = active;
		if (!active) {
			this.#clearPendingListeners();
			this.handleHost.style.display = 'none';
		} else {
			this.handleHost.style.display = 'flex';
			this.handleHost.style.cursor = 'grab';
		}
	}

	#clearPendingListeners() {
		if (this.initialMouseDown && this.handleHost) {
			this.handleHost.removeEventListener('mousemove', this.boundHostMove);
			this.handleHost.removeEventListener('mouseup', this.boundHostUp);
			this.initialMouseDown = null;
		}
	}

	#onHostMouseDown(event) {
		event.stopPropagation();
		event.preventDefault();

		this.initialMouseDown = event;
		this.handleHost.style.cursor = 'grabbing';
		this.handleHost.addEventListener('mousemove', this.boundHostMove);
		this.handleHost.addEventListener('mouseup', this.boundHostUp);
	}

	#onHostMouseMove(event) {
		if (!this.initialMouseDown) {
			return;
		}

		const viewer = this.parentUI.hud.viewer;
		viewer.toolController.__clientToCanvasCoords(this.initialMouseDown);
		viewer.toolController.__clientToCanvasCoords(event);

		const deltaX = this.initialMouseDown.canvasX - event.canvasX;
		const deltaY = this.initialMouseDown.canvasY - event.canvasY;

		if (Math.abs(deltaX) > kClickThreshold || Math.abs(deltaY) > kClickThreshold) {
			this.#clearPendingListeners();
			this.parentUI.dragStart(event);
		}
	}

	#onHostMouseUp() {
		this.#clearPendingListeners();
		this.handleHost.style.cursor = 'grab';
	}
}

function createTraceDragHandleHost(document) {
	const el = document.createElement('div');
	el.classList.add('trace-drag-handle-ui', 'bottom-center-ui');
	el.style.display = 'none';
	return el;
}

function createTraceDragHandleIcon(document) {
	const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	svg.setAttribute('width', '16');
	svg.setAttribute('height', '16');
	svg.setAttribute('viewBox', '0 0 24 24');
	svg.innerHTML = TRACE_HANDLE_SVG;
	return svg;
}
